import { ChangeDetectionStrategy, Component, Signal, ViewEncapsulation } from '@angular/core';
import { cardReasonMapper } from '../../application/utils';
import { CardReasonModel } from '../../application/interfaces';
import { IsRedCardActiveQueryHandler } from '../../application/handlers';
import { PenaltyReason } from '@core-http';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'lib-red-card-indicator',
  templateUrl: './red-card-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  providers: [IsRedCardActiveQueryHandler]
})
export class RedCardIndicatorComponent {
  readonly cardReason: typeof PenaltyReason = PenaltyReason;
  readonly cardReasonMapper: Record<PenaltyReason, CardReasonModel> = cardReasonMapper;

  private readonly isRedCardActiveQueryHandler: IsRedCardActiveQueryHandler = new IsRedCardActiveQueryHandler();

  readonly isRedCardActive: Signal<boolean | undefined> = toSignal(this.isRedCardActiveQueryHandler.isRedCardActive());
}
